import { useCallback, useState } from "react";
import CenteredAlert, { extrairMensagemErro } from "./CenteredAlert";

export function useFeedbackAlert() {
  const [alerta, setAlerta] = useState(null);

  const fechar = useCallback(() => setAlerta(null), []);

  const showError = useCallback((err, fallback = "Ocorreu um erro inesperado.") => {
    setAlerta({
      variant: "error",
      message: extrairMensagemErro(err, fallback),
      onClose: fechar,
    });
  }, [fechar]);

  const showSuccess = useCallback((message, onAfterClose) => {
    setAlerta({
      variant: "success",
      message,
      onClose: () => {
        setAlerta(null);
        onAfterClose?.();
      },
    });
  }, []);

  const showWarning = useCallback((message) => {
    setAlerta({
      variant: "warning",
      message,
      onClose: fechar,
    });
  }, [fechar]);

  const FeedbackAlert = useCallback(
    () => (
      <CenteredAlert
        show={!!alerta}
        variant={alerta?.variant}
        message={alerta?.message}
        onClose={alerta?.onClose}
      />
    ),
    [alerta]
  );

  return { showError, showSuccess, showWarning, FeedbackAlert };
}
